import React from 'react';

const CustomHtmlIframe = () => {
  const htmlContent = `
  <!DOCTYPE html>
  <html lang="id">
  
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>ZOLL AED Plus Landing Page</title>
    <link rel="icon" type="image/x-icon" href="https://zollwebstore.com/media/favicon/websites/1/favicon.png" />
    <link rel="shortcut icon" type="image/x-icon" href="https://zollwebstore.com/media/favicon/websites/1/favicon.png" />
  
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet" />
  
    <!-- Google tag (gtag.js) -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10861005741"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
  
      gtag('config', 'AW-10861005741');
    </script>
  
    <!-- Google Tag Manager -->
    <script>(function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
            new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-P95G5F4T');</script>
    <!-- End Google Tag Manager -->
  
  
    <!-- Event snippet for Purchase conversion page
  In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
    <script>
      function gtag_report_conversion(url) {
        var callback = function () {
          if (typeof (url) != 'undefined') {
            window.open(url, '_blank');
          }
        };
        gtag('event', 'conversion', {
          'send_to': 'AW-10861005741/AHtWCK7X_8AcEK2X97oo',
          'value': 1.0,
          'currency': 'IDR',
          'event_callback': callback
        });
        return false;
      }
    </script>
  
    <style>
      @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700;800&display=swap");
  
      body {
        font-family: "Inter", sans-serif;
      }
  
      @media (min-width: 1775px) {
        .three-xl-cover {
          background-size: cover !important;
        }
      }
  
      @media (min-width: 1536px) {
        .three-xl-py-0 {
          padding-top: 0px !important;
          /* 6rem */
          padding-bottom: 0px !important;
          /* 6rem */
        }
      }
    </style>
    <script>
      tailwind.config = {
        theme: {
          extend: {
            colors: {
              zoll: {
                blue: "#004e98",
                light: "#f3f4f6",
              },
              cta: {
                yellow: "#eab308",
                yellowHover: "#ca8a04",
              },
            },
          },
        },
      };
    </script>
  </head>
  
  <body class="bg-white antialiased text-gray-800">
    <header class="bg-white py-4 border-b border-gray-100">
      <div class="container mx-auto px-4 md:px-8 flex justify-between items-center">
        <div class="flex items-center">
          <img src="/image/beli-zoll-aed-plus/zoll-logo.svg" alt="ZOLL Logo" class="h-8 w-auto sm:h-10" />
          <span class="ml-2 text-sm font-medium text-gray-500 hidden sm:block">Authorized Distributor Indonesia</span>
        </div>
  
        <a href="https://wa.me/6281190087895?text=Halo%21+Saya+menemukan+situs+zoll.co.id+dan+ingin+bertanya+soal+ZOLL+AED.+Bisa+kah+di+bantu%3F+Terima+kasih%21&type=phone_number&app_absent=0"
          target="_blank" class="text-sm font-semibold text-blue-600 hover:text-blue-800" onclick="gtag_report_conversion(this.href)" rel="noopener noreferrer">
          Hubungi Kami
        </a>
      </div>
    </header>
  
    <main>
      <section class="relative py-16 md:py-24 three-xl-py-0 bg-cover three-xl-cover bg-center bg-no-repeat" style="
            background-image: url('/image/beli-zoll-aed-plus/KTI-ZOLL-LANDING-PAGE-BANNER.jpg');
            background-color: rgba(14, 43, 145, 0.5);
          ">
        <div class="absolute inset-0 bg-zoll-blue/50"></div>
  
        <div class="container mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div class="text-white space-y-6">
            <div
              class="inline-flex items-center bg-blue-700 bg-opacity-50 rounded-full px-3 py-1 text-sm font-medium text-blue-100">
              <i class="fas fa-star text-yellow-400 mr-2"></i>
              BEST SELLER AED
            </div>
            <h1 class="text-4xl md:text-5xl font-extrabold leading-tight">
              Beli ZOLL AED Plus
            </h1>
            <p class="text-lg md:text-xl text-blue-100 max-w-lg">
              ZOLL AED andal dengan
              <strong>Real-Time CPR Feedback</strong> untuk meningkatkan peluang
              hidup saat henti jantung mendadak.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 text-sm font-medium text-blue-200 pt-2">
              <div class="flex items-center">
                <i class="fas fa-check-circle text-green-400 mr-2"></i>
                Digunakan di Fasilitas Medis & Publik
              </div>
              <div class="flex items-center">
                <i class="fas fa-check-circle text-green-400 mr-2"></i>
                Distributor Resmi & Bergaransi
              </div>
            </div>
            <div class="pt-4">
              <button
                class="bg-cta-yellow hover:bg-cta-yellowHover text-gray-900 font-bold py-3 px-8 rounded-md shadow-lg transition-all flex items-center">
                <a href="https://wa.me/6281190087895?text=Halo%21+Saya+menemukan+situs+zoll.co.id+dan+ingin+bertanya+soal+ZOLL+AED.+Bisa+kah+di+bantu%3F+Terima+kasih%21&type=phone_number&app_absent=0"
                  target="_blank" onclick="gtag_report_conversion(this.href)" rel="noopener noreferrer">
                  Buat Penawaran
                </a>
                <i class="fas fa-arrow-right ml-3"></i>
              </button>
            </div>
          </div>
          <div class="flex justify-center md:justify-end">
            <img src="/image/beli-zoll-aed-plus/ZOLL-PRODUCT.png" alt="ZOLL AED Plus Unit"
              class="max-w-full h-auto drop-shadow-2xl" style="max-height: 450px" />
          </div>
        </div>
      </section>
  
      <section class="py-20 bg-zoll-light">
        <div class="container mx-auto px-4 md:px-8">
          <h2 class="text-center text-3xl font-bold mb-12 text-gray-900">
            Kenapa Alat AED Sangat Penting?
          </h2>
          <div class="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div class="bg-white p-8 rounded-xl shadow-sm text-center border-t-4 border-blue-500">
              <div class="text-blue-500 text-5xl mb-6">
                <i class="fas fa-heartbeat"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Tanpa Peringatan</h3>
              <p class="text-gray-600">
                Henti jantung bisa terjadi kapan saja, di mana saja, tanpa
                memandang usia.
              </p>
            </div>
            <div class="bg-white p-8 rounded-xl shadow-sm text-center border-t-4 border-blue-500">
              <div class="text-blue-500 text-5xl mb-6">
                <i class="fas fa-chart-line"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Peluang Hidup 70%</h3>
              <p class="text-gray-600">
                Melakukan CPR dengan AED dapat meningkatkan peluang hidup
                sebesar 50-70%.
              </p>
            </div>
            <div class="bg-white p-8 rounded-xl shadow-sm text-center border-t-4 border-blue-500">
              <div class="text-blue-500 text-5xl mb-6">
                <i class="fas fa-users"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Siapapun Bisa</h3>
              <p class="text-gray-600">
                Mudah digunakan oleh masyarakat umum dan efektif dalam situasi
                darurat.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="py-20 bg-white">
        <div class="container mx-auto px-4 md:px-8">
          <div class="text-center mb-16">
            <span class="text-blue-600 font-bold text-sm tracking-wider uppercase">FITUR UNGGULAN</span>
            <h2 class="text-3xl font-bold mt-2 text-gray-900">
              Keunggulan ZOLL AED Plus
            </h2>
          </div>
          <div class="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
            <div class="flex flex-col items-center text-center">
              <div
                class="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 text-3xl mb-6 shadow-sm">
                <i class="fas fa-wave-square"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Real-Time CPR Feedback</h3>
              <p class="text-gray-600">Membantu penolong melakukan kompresi dada dengan kedalaman & ritme yang tepat
                secara langsung.</p>
            </div>
            <div class="flex flex-col items-center text-center">
              <div
                class="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 text-3xl mb-6 shadow-sm">
                <i class="fas fa-volume-up"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Mudah Digunakan</h3>
              <p class="text-gray-600">Panduan suara dan visual yang jelas, didesain khusus untuk pengguna non-medis.</p>
            </div>
            <div class="flex flex-col items-center text-center">
              <div
                class="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center text-blue-600 text-3xl mb-6 shadow-sm">
                <i class="fas fa-shield-alt"></i>
              </div>
              <h3 class="text-xl font-bold mb-3">Tangguh & Andal (IP55)</h3>
              <p class="text-gray-600">Sertifikasi IP55. Tahan debu & lembab, siap dipasang dalam lingkungan ekstrem
                sekalipun.</p>
            </div>
          </div>
        </div>
      </section>
  
      <section class="py-20 bg-zoll-light">
        <div class="container mx-auto px-4 md:px-8">
          <h2 class="text-center text-3xl font-bold mb-12 text-gray-900">
            Spesifikasi Teknis
          </h2>
          <div class="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm overflow-hidden">
            <div class="divide-y divide-gray-100">
              <div class="flex flex-col md:flex-row p-6 hover:bg-gray-50">
                <div class="md:w-1/3 font-bold text-gray-900 mb-2 md:mb-0">Teknologi Real CPR Help®</div>
                <div class="md:w-2/3 text-gray-600 text-sm leading-relaxed">Memberikan panduan CPR secara real-time
                  melalui instruksi suara, teks, dan visual untuk membantu penolong melakukan kompresi dada.</div>
              </div>
              <div class="flex flex-col md:flex-row p-6 hover:bg-gray-50">
                <div class="md:w-1/3 font-bold text-gray-900 mb-2 md:mb-0">Ketahanan Lingkungan</div>
                <div class="md:w-2/3 text-gray-600 text-sm leading-relaxed">Sertifikasi <strong>IP55</strong> memberikan
                  perlindungan optimal terhadap debu dan kelembaban, cocok untuk area publik dan industri.</div>
              </div>
              <div class="flex flex-col md:flex-row p-6 hover:bg-gray-50">
                <div class="md:w-1/3 font-bold text-gray-900 mb-2 md:mb-0">Metronome CPR Adaptif</div>
                <div class="md:w-2/3 text-gray-600 text-sm leading-relaxed">Panduan ritme kompresi otomatis yang membantu
                  penolong menjaga konsistensi kecepatan CPR selama penyelamatan.</div>
              </div>
              <div class="flex flex-col md:flex-row p-6 hover:bg-gray-50">
                <div class="md:w-1/3 font-bold text-gray-900 mb-2 md:mb-0">Sistem Self-Test</div>
                <div class="md:w-2/3 text-gray-600 text-sm leading-relaxed">Pemeriksaan rutin otomatis terhadap baterai
                  dan fungsi perangkat untuk memastikan AED selalu siap pakai.</div>
              </div>
              <div class="flex flex-col md:flex-row p-6 hover:bg-gray-50 border-b-0">
                <div class="md:w-1/3 font-bold text-gray-900 mb-2 md:mb-0">Usia Pakai Komponen</div>
                <div class="md:w-2/3 text-gray-600 text-sm leading-relaxed">Elektroda dan baterai memiliki masa simpan
                  hingga <strong>5 tahun</strong> dengan kapasitas mendukung hingga 225 kali kejutan.</div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <section class="py-24 bg-zoll-blue text-center text-white px-4 md:px-8">
        <div class="container mx-auto max-w-3xl">
          <h2 class="text-3xl md:text-4xl font-bold mb-6 leading-tight">
            Pastikan Lingkungan Anda Siap Menghadapi Keadaan Darurat
          </h2>
          <p class="text-blue-100 text-lg mb-10">
            Dapatkan penawaran khusus dan konsultasi gratis untuk kebutuhan AED di kantor atau fasilitas Anda.
          </p>
          <button
            class="bg-cta-yellow hover:bg-cta-yellowHover text-gray-900 font-bold py-4 px-10 rounded-full shadow-xl transition-all inline-flex items-center text-lg">
            <i class="fab fa-whatsapp text-2xl mr-3"></i>
            <a href="https://wa.me/6281190087895?text=Halo%21+Saya+menemukan+situs+zoll.co.id+dan+ingin+bertanya+soal+ZOLL+AED.+Bisa+kah+di+bantu%3F+Terima+kasih%21&type=phone_number&app_absent=0"
              target="_blank" onclick="gtag_report_conversion(this.href)" rel="noopener noreferrer">
              Konsultasi Gratis Sekarang
            </a>
          </button>
          <p class="text-blue-200 text-sm mt-4">
            Klik untuk terhubung langsung via WhatsApp
          </p>
        </div>
      </section>
  
      <section class="py-16 bg-white">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-3xl font-bold text-center mb-10">Pertanyaan Umum (FAQ)</h2>
  
          <div class="space-y-4">
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <button
                class="w-full px-6 py-4 text-left font-bold text-gray-800 bg-gray-50 hover:bg-gray-100 flex justify-between items-center focus:outline-none"
                onclick="toggleAccordion(1)">
                Apakah AED ini bisa digunakan orang awam?
                <i id="icon-1" class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div id="content-1" class="hidden px-6 py-4 text-gray-600 bg-white border-t border-gray-100">
                Ya. ZOLL AED Plus dirancang dengan panduan suara yang jelas sehingga mudah dioperasikan oleh orang awam
                yang sudah menerima pelatihan BHD.
              </div>
            </div>
  
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <button
                class="w-full px-6 py-4 text-left font-bold text-gray-800 bg-gray-50 hover:bg-gray-100 flex justify-between items-center focus:outline-none"
                onclick="toggleAccordion(2)">
                Apakah produk ini sesuai regulasi di Indonesia?
                <i id="icon-2" class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div id="content-2" class="hidden px-6 py-4 text-gray-600 bg-white border-t border-gray-100">
                Ya. Kami menyediakan unit resmi dan dukungan aftersales penuh sesuai regulasi alat kesehatan di Indonesia.
              </div>
            </div>
  
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <button
                class="w-full px-6 py-4 text-left font-bold text-gray-800 bg-gray-50 hover:bg-gray-100 flex justify-between items-center focus:outline-none"
                onclick="toggleAccordion(3)">
                Apakah tersedia pelatihan AED?
                <i id="icon-3" class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div id="content-3" class="hidden px-6 py-4 text-gray-600 bg-white border-t border-gray-100">
                Pelatihan penggunaan AED akan diberikan jika Anda membeli ZOLL AED oleh kami (berdasarkan permintaan).
              </div>
            </div>
  
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <button
                class="w-full px-6 py-4 text-left font-bold text-gray-800 bg-gray-50 hover:bg-gray-100 flex justify-between items-center focus:outline-none"
                onclick="toggleAccordion(4)">
                Apakah pengiriman AED Gratis Ongkir?
                <i id="icon-4" class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div id="content-4" class="hidden px-6 py-4 text-gray-600 bg-white border-t border-gray-100">
                Pengiriman gratis hanya untuk daerah JABODETABEK. Di luar jangkauan tersebut akan dikenakan ongkos kirim.
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  
    <footer class="bg-gray-900 text-gray-400 py-8 text-center text-sm">
      <p>&copy; 2025 Distributor Resmi ZOLL Indonesia. All rights reserved.</p>
    </footer>
  
    <script>
      function toggleAccordion(id) {
        const content = document.getElementById('content-'+id);
        const icon = document.getElementById('icon-'+id);
  
        if (content.classList.contains("hidden")) {
          content.classList.remove("hidden");
          icon.classList.remove("fa-chevron-down");
          icon.classList.add("fa-chevron-up");
        } else {
          content.classList.add("hidden");
          icon.classList.remove("fa-chevron-up");
          icon.classList.add("fa-chevron-down");
        }
      }
    </script>
  
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P95G5F4T" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
  </body>
  
  </html>
  `;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
      }}
    >
      <iframe
        srcDoc={htmlContent}
        title="ZOLL AED Plus"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>

  );
};

export default CustomHtmlIframe;
